// ./LeadListCreateThemeProvider.tsx
import { ThemeProvider, createTheme, CssBaseline, GlobalStyles } from '@mui/material';
import { ReactNode } from 'react';
import { baseTheme } from '../../../theme';

const leadListTheme = createTheme({
  ...baseTheme,
  components: {
    ...baseTheme.components,
    MuiButton: {
      ...baseTheme.components?.MuiButton,
      styleOverrides: {
        ...(baseTheme.components?.MuiButton?.styleOverrides || {}),
        root: {
          ...((baseTheme.components?.MuiButton?.styleOverrides?.root as object) || {}),
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
  },
});

const globalStyles = (
  <GlobalStyles
    styles={{
      '.slide-down-enter': {
        position: 'absolute',
        width: '100%',
        transform: 'translateY(-100%)',
        opacity: 0,
      },
      '.slide-down-enter-active': {
        transform: 'translateY(0%)',
        opacity: 1,
        transition: 'all 400ms ease',
      },
      '.slide-down-exit': {
        position: 'absolute',
        width: '100%',
        transform: 'translateY(0%)',
        opacity: 1,
      },
      '.slide-down-exit-active': {
        transform: 'translateY(100%)',
        opacity: 0,
        transition: 'all 400ms ease',
      },
    }}
  />
);

export const LeadListCreateThemeProvider = ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={leadListTheme}>
    <CssBaseline />
    {globalStyles}
    {children}
  </ThemeProvider>
);
